import { sections } from "../../../common/config";

type Section = "buffer" | "history" | "faqs" | "flavor" | "contact";
const { landing, buffer, history, faqs, flavor, contact } = sections.height;

/**
 * Get the vh ratio of the particular section in the page
 * @param section 
 * @param ratio In range of 0~1
 * @returns Vh ratio
 */
export function getVh(section: Section, ratio: number = 0) {
  let vh = 0;

  switch (section) {
    case "buffer":
      vh = landing + (ratio * buffer);
      break;
    case "history":
      vh = landing + buffer + (ratio * history);
      break;
    case "faqs":
      vh = landing + buffer + history + (ratio * faqs);
      break;
    case "flavor":
      vh = landing + buffer + history + faqs + (ratio * flavor);
      break;
    case "contact":
      vh = landing + buffer + history + faqs + flavor + (ratio * contact);
      break;
  }

  return vh;
}